import estasseguroAvatar1 from "../assets/bg/estasseguro-avatar-1.png";
import estasseguroAvatar2 from "../assets/bg/estasseguro-avatar-2.png";
import estasseguroAvatar3 from "../assets/bg/estasseguro-avatar-3.png";
import estasseguroAvatar4 from "../assets/bg/estasseguro-avatar-4.png";

const ESTASSEGURO_AVATARS = [
	estasseguroAvatar1,
	estasseguroAvatar2,
	estasseguroAvatar3,
	estasseguroAvatar4,
];

/**
 * Devuelve la URL (bundler) de uno de los avatares «¿estás seguro?» al azar.
 * Usar en cada apertura de modal (no cachear en módulo) para variar entre intentos.
 */
export function getRandomEstasseguroAvatar() {
	return ESTASSEGURO_AVATARS[Math.floor(Math.random() * ESTASSEGURO_AVATARS.length)];
}
